<div class="step-1-wrapper" [ngStyle]="{ '--bg-color': community?.color1 ? community.color1 : '#3B82F6' }">

  @if (!isReloadingInfo) {

    <form [formGroup]="form">

      <div class="step1-column">

        <section class="mb-4">

          <h4 class="fw-600 mb-3">{{ (preReservationLabels ? 'PREAPPOINTMENT.center' : 'PRIORAPPOINTMENT.center') | translate }}</h4>

          @if (!loadingCenters) {

            <div class="step1-tiles-row d-flex flex-wrap gap-2 mb-3">

              @for (center of centerDTOs; track center.id) {

                <div class="step1-tile-wrap">

                  <button

                    type="button"

                    class="selection-tile selection-tile--align-top btn w-100 h-100"

                    (click)="setCenter(center)"

                    [class.selection-tile--selected]="activeCenter?.id === center.id"

                    [style.--accent]="community?.color1 || '#3B82F6'"

                  >

                    <span class="selection-tile__visual">

                      @if (center.path) {

                        <app-convert-svg

                          [currentColor]="activeCenter?.id === center.id ? 'white' : 'black'"

                          [path]="center.path | imageUrl"

                          height="100%"

                          width="100%"

                        />

                      } @else {

                        <i class="fa-solid fa-house selection-tile__fallback-icon" aria-hidden="true"></i>

                      }

                    </span>

                    <span class="selection-tile__body">

                      <span class="selection-tile__label">{{ center.name }}</span>

                    </span>

                  </button>

                </div>

              }

            </div>

          }

          @if (loadingCenters) {

            <p-skeleton styleClass="w-100" height="4rem" />

          }

          @if (form.controls['center'].invalid && form.controls['center'].touched) {

            <p class="text-danger">{{ (preReservationLabels ? 'PREAPPOINTMENT.select_center_error' : 'PRIORAPPOINTMENT.select_center_error') | translate }}</p>

          }

          @if (!loadingCenters && !centerDTOs.length) {

            <p>{{ (preReservationLabels ? 'PREAPPOINTMENT.notCentersConfiguredYet' : 'PRIORAPPOINTMENT.notCentersConfiguredYet') | translate }}</p>

          }

        </section>

        @if (activeCenter) {

          <section class="mb-4">

            <h4 class="fw-600 mb-3">{{ (preReservationLabels ? 'PREAPPOINTMENT.pickGroupOrServiceTitle' : 'PRIORAPPOINTMENT.pickGroupOrServiceTitle') | translate }}</h4>

            @if (contextCenterName) {

              <div class="pick-context mb-3">

                <div class="pick-context__name">{{ contextCenterName }}</div>

                @if (contextCenterLocation) {

                  <div class="pick-context__location">

                    <i class="fa-solid fa-location-dot pick-context__location-icon" aria-hidden="true"></i>

                    <span>{{ contextCenterLocation }}</span>

                  </div>

                }

              </div>

            }

            @if (loadingPick) {

              <div class="d-flex gap-2 flex-wrap">

                <p-skeleton width="140px" height="3rem"></p-skeleton>

                <p-skeleton width="140px" height="3rem"></p-skeleton>

                <p-skeleton width="140px" height="3rem"></p-skeleton>

              </div>

            } @else {

              <div class="step1-tiles-row d-flex flex-wrap gap-2 mb-3">

                @for (item of pickItems; track trackByCardId($index, item)) {

                  <div class="step1-tile-wrap">

                    <button

                      type="button"

                      class="selection-tile btn w-100 h-100"

                      (click)="onPickItem(item)"

                      [class.selection-tile--selected]="selectedPick?.id === item.id && selectedPick?.itemType === item.itemType"

                      [style.--accent]="community?.color1 || '#3B82F6'"

                    >

                      <span class="selection-tile__visual">

                        @if (item.path) {

                          <app-convert-svg

                            [currentColor]="selectedPick?.id === item.id && selectedPick?.itemType === item.itemType ? 'white' : 'black'"

                            [path]="item.path | imageUrl"

                            height="100%"

                            width="100%"

                          />

                        } @else {

                          <i

                            class="fa-solid selection-tile__fallback-icon"

                            [class.fa-layer-group]="item.itemType === ITEM_TYPE_GROUP"

                            [class.fa-calendar-check]="item.itemType === ITEM_TYPE_RESOURCE"

                            aria-hidden="true"

                          ></i>

                        }

                      </span>

                      <span class="selection-tile__body">

                        <span class="selection-tile__label">{{ item.name }}</span>

                      </span>

                    </button>

                  </div>

                }

              </div>

              @if (!pickItems.length) {

                <p>{{ (preReservationLabels ? 'PREAPPOINTMENTCREATE.noGroupsOrResources' : 'PRIORAPPOINTMENTCREATE.noGroupsOrResources') | translate }}</p>

              }

              @if (groupHasNoResources) {

                <p class="text-warning">{{ (preReservationLabels ? 'PREAPPOINTMENT.group_has_no_resources' : 'PRIORAPPOINTMENT.group_has_no_resources') | translate }}</p>

              }

              @if (form.controls['service'].invalid && form.controls['service'].touched && pickItems.length) {

                <p class="text-danger">{{ (preReservationLabels ? 'PREAPPOINTMENT.select_service_error' : 'PRIORAPPOINTMENT.select_service_error') | translate }}</p>

              }

            }

            @if (activeService?.description) {

              <div class="banner-service mb-4" [innerHTML]="activeService.description"></div>

            }

          </section>

        }

        @if (activeCenter && (loadingCalendarPanel || loadingResourceSlots || (activeService && !groupHasNoResources))) {

          <section class="mb-4">

            <h4 class="fw-600 mb-3">{{ (preReservationLabels ? 'PREAPPOINTMENT.date_time' : 'PRIORAPPOINTMENT.date_time') | translate }}</h4>

            @if (loadingCalendarPanel) {

              <div class="calendar-panel-skeleton" aria-hidden="true">

                <p-skeleton width="100%" height="16rem" styleClass="mb-3 rounded-2"></p-skeleton>

                <p-skeleton width="100%" height="2.5rem" styleClass="mb-2"></p-skeleton>

                <p-skeleton width="80%" height="2.5rem"></p-skeleton>

              </div>

            } @else {

              <div class="step1-schedule-layout">

                <div class="step1-schedule-layout__calendar">

                  <p-calendar

                    class="max-w-full small-calendar"

                    [(ngModel)]="selectedDay"

                    [ngModelOptions]="{ standalone: true }"

                    [disabledDates]="disabledDates"

                    (onSelect)="onCalendarSelect($event)"

                    [inline]="true"

                    [showWeek]="true"

                    [minDate]="minDate"

                    [maxDate]="maxDate"

                  />

                  @if (form.controls['date'].invalid && form.controls['date'].touched) {

                    <p class="text-danger">{{ (preReservationLabels ? 'PREAPPOINTMENT.select_date_error' : 'PRIORAPPOINTMENT.select_date_error') | translate }}</p>

                  }

                </div>

                <div class="step1-schedule-layout__side">

                  @if (selectedDay && activeService && !groupHasNoResources && (loadingResourceSlots || loadingDurationSlots || filteredResourceSlots.length > 0)) {

                    <div class="duration-block mb-3">

                      <h4 class="fw-600 mb-2 small text-uppercase text-muted">{{ (preReservationLabels ? 'PREAPPOINTMENT.select_duration' : 'PRIORAPPOINTMENT.select_duration') | translate }}</h4>

                      <div class="d-flex flex-wrap gap-2 mb-2">

                        @if (loadingResourceSlots || loadingDurationSlots) {

                          @for (_ of skeletonDurationPlaceholders; track $index) {

                            <p-skeleton width="5.5rem" height="2.25rem" styleClass="rounded-pill"></p-skeleton>

                          }

                        } @else {

                          @for (slot of filteredResourceSlots; track trackResourceSlot($index, slot)) {

                            <button

                              type="button"

                              class="btn btn-sm rounded-pill px-3 duration-pill"

                              [class.text-white]="selectedSlot === slot"

                              [style.background-color]="selectedSlot === slot ? (community?.color1 || '#3B82F6') : 'white'"

                              [style.border-color]="community?.color1 || '#dee2e6'"

                              (click)="selectSlot(slot)"

                            >

                              {{ slot.durationMinutes }} {{ (preReservationLabels ? 'PREAPPOINTMENT.minutes' : 'PRIORAPPOINTMENT.minutes') | translate }}

                            </button>

                          }

                        }

                      </div>

                    </div>

                  }

                  @if (selectedDay && !loadingResourceSlots && !loadingDurationSlots && (filteredResourceSlots.length <= 1 || selectedSlot)) {

                    <div class="hours-section">

                      @if (!loadHours && visibleHourSlots.length) {

                        <h5 class="hours-section-title">{{ (preReservationLabels ? 'PREAPPOINTMENT.availableHoursTitle' : 'PRIORAPPOINTMENT.availableHoursTitle') | translate }}</h5>

                      }

                      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2" [class.opacity-50]="loadHours">

                        @if (!loadHours) {

                          <label class="mb-0 small text-muted" for="prior-show-only-available-hours">{{ (preReservationLabels ? 'PREAPPOINTMENT.showOnlyAvailableHours' : 'PRIORAPPOINTMENT.showOnlyAvailableHours') | translate }}</label>

                        }

                        @if (!loadHours) {

                          <p-inputSwitch

                            inputId="prior-show-only-available-hours"

                            [(ngModel)]="showOnlyAvailableHours"

                            [ngModelOptions]="{ standalone: true }"

                            (ngModelChange)="onShowOnlyAvailableHoursChange()"

                          />

                        }

                      </div>

                      <div class="hours-grid" [class.hours-grid--loading]="loadHours">

                        @if (loadHours) {

                          @for (_ of skeletonHourPlaceholders; track $index) {

                            <p-skeleton width="100%" height="3.5rem" styleClass="hours-grid__skeleton"></p-skeleton>

                          }

                        } @else if (!visibleHourSlots.length) {

                          <p class="text-muted small mb-0 hours-grid__empty">{{ (preReservationLabels ? 'PREAPPOINTMENT.no_hours_this_day' : 'PRIORAPPOINTMENT.no_hours_this_day') | translate }}</p>

                        } @else {

                          @for (t of visibleHourSlots; track trackTimeAvailability($index, t)) {

                            <button

                              type="button"

                              class="hour-slot"

                              [class.active]="!timeSlotDisabled(t) && activeTime === t.time"

                              [class.disponible]="!timeSlotDisabled(t) && !hourSlotLastPlaces(t)"

                              [class.ultimas-plazas]="hourSlotLastPlaces(t)"

                              [class.no-disponible]="timeSlotDisabled(t)"

                              [disabled]="timeSlotDisabled(t)"

                              (click)="selectTime(t.time)"

                            >

                              <span class="hour-value" [class.struck]="timeSlotDisabled(t)">{{ t.time }}</span>

                              <span class="hour-label">
                                @if (preReservationLabels) {
                                  {{ ('PREAPPOINTMENT.' + hourSlotLabelKey(t).slice('PRIORAPPOINTMENT.'.length)) | translate }}
                                } @else {
                                  {{ hourSlotLabelKey(t) | translate }}
                                }
                              </span>

                            </button>

                          }

                        }

                      </div>

                      @if (!loadHours && hasMoreHours) {

                        <div class="text-center mt-2">

                          <button type="button" class="btn btn-link btn-sm p-0" (click)="showAllHours = true">

                            {{ (preReservationLabels ? 'PREAPPOINTMENT.showMoreHours' : 'PRIORAPPOINTMENT.showMoreHours') | translate }}

                          </button>

                        </div>

                      }

                    </div>

                  }

                </div>

              </div>

              @if (selectedPick?.itemType === ITEM_TYPE_GROUP && activeTime && (loadingGroupResources || groupResourcesForTimeSlot.length > 1)) {

                <div class="group-resources-block mt-4">

                  <h4 class="fw-600 mb-3">{{ (preReservationLabels ? 'PREAPPOINTMENT.selectResourceTitle' : 'PRIORAPPOINTMENT.selectResourceTitle') | translate }}</h4>

                  <div class="step1-tiles-row d-flex flex-wrap gap-2">

                    @if (loadingGroupResources) {

                      @for (_ of skeletonDurationPlaceholders; track $index) {

                        <div class="step1-tile-wrap">

                          <p-skeleton width="100%" height="4.75rem" styleClass="rounded-2"></p-skeleton>

                        </div>

                      }

                    } @else {

                      @for (svc of groupResourcesForTimeSlot; track trackGroupResource($index, svc)) {

                        <div class="step1-tile-wrap">

                          <button

                            type="button"

                            class="selection-tile selection-tile--with-price btn w-100 h-100"

                            (click)="selectGroupResource(svc)"

                            [class.selection-tile--selected]="selectedGroupResourceId === svc.id"

                            [style.--accent]="community?.color1 || '#3B82F6'"

                          >

                            <span class="selection-tile__visual">

                              @if (svc.path) {

                                <app-convert-svg

                                  [currentColor]="selectedGroupResourceId === svc.id ? 'white' : 'black'"

                                  [path]="svc.path | imageUrl"

                                  height="100%"

                                  width="100%"

                                />

                              } @else {

                                <i class="fa-solid fa-calendar-check selection-tile__fallback-icon" aria-hidden="true"></i>

                              }

                            </span>

                            <span class="selection-tile__body">

                              <span class="selection-tile__label">{{ svc.name }}</span>
                              @if (getGroupResourcePrice(svc.id); as priceInfo) {
                                <span class="selection-tile__price">
                                  @if (priceInfo.isFree) {
                                    {{ (preReservationLabels ? 'PREAPPOINTMENT.priceFree' : 'PRIORAPPOINTMENT.priceFree') | translate }}
                                  } @else {
                                    {{ (preReservationLabels ? 'PREAPPOINTMENT.resourcePriceMinutesColon' : 'PRIORAPPOINTMENT.resourcePriceMinutesColon') | translate: { minutes: priceInfo.durationMinutes } }}
                                    <strong class="selection-tile__price-value">{{ priceInfo.userPrice | number:'1.2-2' }} €</strong>
                                  }
                                </span>
                              }

                            </span>

                          </button>

                        </div>

                      }

                    }

                  </div>

                  @if (submitAttempt && needsGroupResourcePicked()) {

                    <p class="text-danger small mb-0 mt-2">{{ (preReservationLabels ? 'PREAPPOINTMENT.select_resource_error' : 'PRIORAPPOINTMENT.select_resource_error') | translate }}</p>

                  }

                </div>

              }

              @if (form.controls['time'].invalid && form.controls['time'].touched) {

                <p class="text-danger mt-2">{{ (preReservationLabels ? 'PREAPPOINTMENT.select_time_error' : 'PRIORAPPOINTMENT.select_time_error') | translate }}</p>

              }

            }

          </section>

        }

      </div>

    </form>

  } @else {

    <p-skeleton styleClass="w-100" height="20rem"></p-skeleton>

  }

</div>
